import { useEffect } from 'react';
import { AuthContextProps } from 'react-oidc-context';
import applicationSettings from '../infrastructure/config';
import { buildAcrValues } from './constants';
import { resolveOidpid } from './oidpidStorage';

export const ensureAuthenticated = (auth: AuthContextProps) => {
  useEffect(() => {
    if (!auth?.isAuthenticated && !auth?.isLoading) {
      if (!auth.error) {
        const resolvedOidpid = resolveOidpid(
          applicationSettings.allowedOverrideDefaultOidcProviderIds ?? []
        );

        auth.signinRedirect({
          acr_values: buildAcrValues(resolvedOidpid),
        });
      }
    }
  }, [auth, auth?.isAuthenticated, auth?.isLoading, auth?.error]);
};

export const triggerSigninRedirect = (auth: AuthContextProps, oidpid?: string | null) => () => {
  if (!auth?.isLoading) {
    sessionStorage.removeItem(
      `oidc.user:${applicationSettings.oidcServiceUrl}:${applicationSettings.oidcClientId}`
    );

    auth.signinRedirect({
      acr_values: buildAcrValues(oidpid),
    });
  }
};
